import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertCircle, ArrowLeft, RotateCw } from 'lucide-react';
import { Button } from '../../../../../components/ui/button';

interface InitializationErrorInfoProps {
    showTryAgain: boolean;
    onBackClick: () => void;
    onTryAgainClick: () => void;
}

const InitializationErrorInfo = (props: InitializationErrorInfoProps) => {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col items-center justify-center py-12 px-6">
            <div className="max-w-md w-full space-y-6">
                {/* Error Icon */}
                <div className="flex justify-center">
                    <div className="bg-red-100 rounded-full p-4">
                        <AlertCircle className="h-12 w-12 text-red-600" />
                    </div>
                </div>

                {/* Error Message */}
                <div className="text-center space-y-2">
                    <h2 className="text-2xl font-bold text-slate-900">
                        {t('book_location.error.payment_initialization_title', {
                            defaultValue: 'Payment Initialization Failed'
                        })}
                    </h2>
                    <p className="text-slate-600">
                        {t('book_location.error.payment_initialization_info', {
                            defaultValue: 'We encountered an error while setting up your payment. Please try again or go back to update your selection.'
                        })}
                    </p>
                </div>

                {/* Action Buttons */}
                <div className="space-y-3">
                    {props.showTryAgain && (
                        <Button
                            onClick={props.onTryAgainClick}
                            className="w-full"
                            size="lg"
                        >
                            <RotateCw className="mr-2 h-5 w-5" />
                            {t('book_location.payment.try_again', {
                                defaultValue: 'Try Again'
                            })}
                        </Button>
                    )}
                    
                    <Button
                        onClick={props.onBackClick}
                        variant="outline"
                        className="w-full"
                        size="lg"
                    >
                        <ArrowLeft className="mr-2 h-5 w-5" />
                        {t('book_location.payment.go_back', {
                            defaultValue: 'Go Back'
                        })}
                    </Button>
                </div>

                {/* Help Text */}
                <p className="text-sm text-slate-500 text-center">
                    {t('book_location.error.payment_help_text', {
                        defaultValue: 'If the problem persists, please contact support.'
                    })}
                </p>
            </div>
        </div>
    );
};

export default InitializationErrorInfo;
